import React from 'react';
import { styled } from '@mui/material/styles';
import { Switch } from '@mui/material';

const CustomSwitch2 = styled((props) => <Switch {...props} />)(({ theme }) => ({
  '&.MuiSwitch-root': {
    width: '52px',
    paddingLeft: '0',
    height: '26px',
    padding: '0'
  },
  '& .Mui-disabled + .MuiSwitch-track': {
    backgroundColor: theme.palette.grey[300]
  },
  '&  .MuiButtonBase-root': {
    top: '5px',
    left: '-2px',
    paddingBottom: 0,
    paddingTop: 0
  },
  '&  .MuiButtonBase-root.Mui-checked .MuiSwitch-thumb': {
    backgroundColor: 'primary.main'
  },
  '& .MuiSwitch-thumb': {
    width: '15px',
    height: '15px',
    borderRadius: '4px'
  },

  '& .MuiSwitch-track': {
    backgroundColor: theme.palette.grey[200],
    opacity: 1,
    borderRadius: '5px'
  },
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& + .MuiSwitch-track': {
        backgroundColor: 'primary',
        opacity: 0.18
      }
    }
  }
}));

export default CustomSwitch2;
